import type { ApiErrorCode } from "@unfiddle/core/api/error"
import type { ApiRoutes } from "@unfiddle/core/api/types"
import { type ClientResponse, hc } from "hono/client"
import type { StatusCode } from "hono/utils/http-status"
import { env } from "@/env"

export const api = hc<ApiRoutes>(env.API_URL, {
   fetch: ((input, init) => {
      return fetch(input, {
         ...init,
         credentials: "include",
      })
   }) satisfies typeof fetch,
})

type HonoResponse<T> = Promise<ClientResponse<T, StatusCode, "json">>

export const query = <T>(fn: () => HonoResponse<T>) => {
   return async () => {
      const res = await fn()
      if (res.ok) return res.json()
      return Promise.reject(await res.json())
   }
}

export type ApiClientError = {
   code: ApiErrorCode
   message: string
}

export const CACHE_SHORT = 30 * 1000 // 30 sec
export const CACHE_AWHILE = 900 * 1000 // 15 min
export const CACHE_FOREVER = Infinity
